import {Injectable} from "@angular/core";
import {
  HttpEvent, HttpInterceptor, HttpHandler,
  HttpRequest, HttpErrorResponse
} from "@angular/common/http";
import {Observable} from "rxjs";
import {catchError} from "rxjs/operators";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  REDIRECT_URL: string = window.location.origin + '/ftportal/login';
  API_PATHS : string = '/api/'

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 || !(error.url.includes(this.API_PATHS))) {
          const httpsReq: HttpRequest<any> = req.clone({
            url: req.url.replace(req.url, this.REDIRECT_URL)
          });
          document.location.href = this.REDIRECT_URL;
          return next.handle(httpsReq);
        }
        return next.handle(req);
      })
    );
  }
}
